// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"75":"83da75b7","95":"583ea4f3","266":"f573f1b8","453":"54292a4b","745":"9918b686","765":"eb9e4a44","778":"4892c744","958":"bf2d3e97"}[chunkId] + ".chunk.js";
};